import React, { useState, useEffect } from 'react'; // Add useEffect here
import HeaderMobile from './HeaderMobile.js';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import './Add_User.css';
import Footer from './Footer.js';  // Import Footer component
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from "./Constants.js";

const Add_DressColor = () => {
  const [newUser, setNewUser] = useState({
    dress_color: '',
  });
  const [formError, setFormError] = useState(null);
  const [dressTypes, setDressTypes] = useState([]);
  const [dressSizes, setDressSizes] = useState([]);

  // Add missing states for user, error, and loading
  const [user, setUser] = useState(null);  // To store the user data (isAdmin or similar)
  const [error, setError] = useState(null); // To store error message if any
  const [loading, setLoading] = useState(true); // To manage loading state
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const navigate = useNavigate(); // Use navigate hook

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewUser({
      ...newUser,
      [name]: value,
    });
  };



  // Fetch user profile using useEffect
  useEffect(() => {
    const token = localStorage.getItem('authToken');

    console.log(token); // for debugging
    const fetchProfile = async () => {
      try {
        const response = await fetch(`${BASE_URL}profile`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        const data = await response.json();
        setUser(data.profile.is_uniform_access_given); // Assuming the response contains the user profile info
      } catch (error) {
        setError(error.message); // Handle errors
        console.error('Error fetching profile:', error);
      } finally {
        setLoading(false); // Set loading to false after data fetch completes
      }
    };

    fetchProfile();
  }, []);

  useEffect(() => {
      const fetchDressTypes = async () => {
        if (!newUser.gender) {
          setDressTypes([]);
          return;
        }
  
        try {
          const token = localStorage.getItem('authToken');
          const response = await fetch(`${BASE_URL}dress_types_by_gender`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({ gender: newUser.gender }),
          });
  
          const data = await response.json();
          const activeTypes = (data.dressTypes || []).filter(type => type.status === 'A');
          setDressTypes(activeTypes);
        } catch (err) {
          setError(err.message);
        } finally {
          setLoading(false);
        }
      };
  
      fetchDressTypes();
    }, [newUser.gender]);


  useEffect(() => {
  const fetchDressSizes = async () => {
    if (!newUser.type_id) {
      setDressSizes([]); // Reset sizes
      return;
    }

    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${BASE_URL}dress_sizes_by_type`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ type_id: newUser.type_id }),
      });

      const data = await response.json();
      const activeSizes = (data.dressTypes || []).filter(size => size.status === 'A'); // <--- KEY FIX
      setDressSizes(activeSizes);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  fetchDressSizes();
}, [newUser.type_id]);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Simple form validation
    if (!newUser.dress_color) {
      setFormError('field are required.');
      return;
    }

    try {
      const token = localStorage.getItem('authToken');
      const formData = new FormData();
      formData.append('dress_color', newUser.dress_color);
      formData.append('dress_type', newUser.type_id);
      formData.append('dress_size', newUser.size_id);
      formData.append('gender', newUser.gender);


      const response = await fetch(`${BASE_URL}add_dresscolor`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.status) {
        throw new Error('Failed to add user');
      }

      // Redirect to the Manage User page after successful submission
      navigate('/manage_dresscolor'); // You can modify this route if needed

    } catch (err) {
      setFormError(err.message);
    }
  };
  const handleToggleSidebar = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarOpen(prev => !prev);
    }
  };
  const handleCancel = () => {
    navigate('/manage_dresscolor');
  }
  return (
    <div className="page-wrapper">
      <HeaderMobile />
      <Sidebar isOpen={isSidebarOpen} />
      <div className="page-container">
        <Header onToggleSidebar={handleToggleSidebar} isSidebarOpen={isSidebarOpen} />
        <div className="main-content">
          <div className="section__content section__content--p30">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-6 offset-lg-3">
                  {/* Add User Card */}
                  <div className="card add-user-card">
                    <div className="card-header">
                      <h2>Add New Dress Color</h2>
                    </div>
                    <div className="card-body">
                      {/* Add User Form */}
                      <form onSubmit={handleSubmit}>
                        {formError && <div className="alert alert-danger">{formError}</div>}
                        <div className='form-group'>
                          <label>Gender</label>
                          <select
                            name="gender"
                            value={newUser.gender}
                            onChange={handleInputChange}
                            className='form-control'
                            required
                          >
                            <option value="">Select Gender</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                          </select>
                        </div>
                        <div className="form-group">
                          <label>Type</label>
                          <select
                            name="type_id"
                            className="form-control"
                            value={newUser.type_id} 
                            onChange={handleInputChange}
                            required
                          >
                            <option value="">Select Type</option>
                            {dressTypes.map((type) => (
                              <option key={type.id} value={type.id}>{type.dress_type}</option>
                            ))}
                          </select>
                        </div>
                        <div className="form-group">
                          <label>Size</label>
                          <select
                            name="size_id"
                            className="form-control"
                            value={newUser.size_id} 
                            onChange={handleInputChange}
                            required
                          >
                            <option value="">Select Size</option>
                            {dressSizes.map((size) => (
                              <option key={size.id} value={size.id}>{size.dress_size}</option>
                            ))}
                          </select>
                        </div>


                        <div className="form-group">
                          <label htmlFor="dress_color">Dress Color</label>
                          <input
                            type="text"
                            id="dress_color"
                            name="dress_color"
                            className="form-control"
                            value={newUser.dress_color}
                            onChange={handleInputChange}
                          />
                        </div>
                        <div style={{ display: 'flex', gap: '10px' }}>
                          <button type="submit" className="btn btn-primary">
                            Submit
                          </button>
                          <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                            Cancel
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer /> {/* Footer will stick to the bottom */}
      </div>
    </div>
  );
};

export default Add_DressColor;
